// extracted by mini-css-extract-plugin
module.exports = {"tag":"tagsCol_tag_zSZic"};